import { useQuery } from "react-query";
import { getEventConfig } from "api/api";
import useOrganizationContext from "hooks/useOrganizationContext";

const useEventConfig = ({ eventId, params = null, options = {} } = {}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();
	return useQuery(
		["event-config-detail", organizationId, eventId, params],
		() => getEventConfig(organizationId, eventId, params),
		{
			...options,
			enabled: (options?.enabled ?? true) && Boolean(organizationId),
			select: res => res.response
		}
	);
};

export { useEventConfig };
